import { ProfileItem } from "PFApp/components/profile_item";
import { buildProfilesOptionsFetcher } from "PFApp/helpers/options/profiles_options";
import { PermissionRule } from "PFTypes";

import css from "./exception_modal_content.module.scss";

export const fetchOptions = buildProfilesOptionsFetcher({
  profileVisibility: "active",
  policyName: PermissionRule.AuditApprover,
  renderDisplayElement: (profile) => (
    <ProfileItem profile={profile} classes={{ content: css.profileItemContent }} />
  )
});
